import { externalSettings as schemaSettings } from './schemas';
import apiClient from './apiClient';
import ExternalSettingsDataStore from '../../datastores/ExternalSettingsDataStore';

class ExternalSettingsDataStoreGraphQL implements ExternalSettingsDataStore {
  async getStudentPortalSettings() {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaSettings.getStudentPortalSettings,
        fetchPolicy: 'cache-first'
      });
      return {
        config: response.data.serviceInformation.config
      };
    } catch (error) {
      throw new Error('error externalSettings');
    }
  }

  async getBannerList() {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaSettings.getBannerList,
        fetchPolicy: 'cache-first'
      });
      return response.data.externalSettings.bannerList;
    } catch (error) {
      throw new Error('error externalSettings');
    }
  }

  async getBannerDetail(bannerId: number) {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaSettings.bannerDetail,
        variables: { bannerId }
      });
      return response.data.externalSettings.bannerDetail;
    } catch (error) {
      throw new Error('error externalSettings');
    }
  }

  async getLinksInterest() {
    const storedData = localStorage.getItem('linksDates');

    if (storedData) {
      return JSON.parse(storedData);
    }

    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaSettings.getLinksInterest
      });

      const linksDates = response.data.startApp.linksInterest;
      if (linksDates) {
        localStorage.setItem('linksDates', JSON.stringify(linksDates));
      }
      return linksDates;
    } catch (error) {
      throw new Error('error externalSettings');
    }
  }

  async getVersion() {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaSettings.getVersion
      });
      return response.data.lastVersion;
    } catch (error) {
      throw new Error('error externalSettings');
    }
  }
}

export default ExternalSettingsDataStoreGraphQL;
